export default __webpack_public_path__ + "static/media/image-board-study-now-n-w@3x.251c945e.png";